/**
 * 品牌支付配置入口
 */
import type { BrandPaymentConfig, ChapterConfig, PayPageConfig, SubscribePageConfig } from '../types'
import { rocnovelPaymentConfig } from './rocnovel'
import { ocereadPaymentConfig } from './oceread'
import { talewavePaymentConfig } from './talewave'
import { ficmoonPaymentConfig } from './ficmoon'
import { novelarcPaymentConfig } from './novelarc'
import { storyellaPaymentConfig } from './storyella'
import { florastoryPaymentConfig } from './florastory'
import { silktalePaymentConfig } from './silktale'
import { pearlaPaymentConfig } from './pearla'
import { fictoraPaymentConfig } from './fictora'
import { marinovelPaymentConfig } from './marinovel'
import { flipnovelPaymentConfig } from './flipnovel'
import { moonpagePaymentConfig } from './moonpage'
import { storlynPaymentConfig } from './storlyn'
import { novarisPaymentConfig } from './novaris'
import { loadBrandConfig } from '@/utils/loadBrandConfig'

// 导出所有品牌配置
export { rocnovelPaymentConfig } from './rocnovel'
export { ocereadPaymentConfig } from './oceread'
export { talewavePaymentConfig } from './talewave'
export { ficmoonPaymentConfig } from './ficmoon'
export { novelarcPaymentConfig } from './novelarc'
export { storyellaPaymentConfig } from './storyella'
export { florastoryPaymentConfig } from './florastory'
export { silktalePaymentConfig } from './silktale'
export { pearlaPaymentConfig } from './pearla'
export { fictoraPaymentConfig } from './fictora'
export { marinovelPaymentConfig } from './marinovel'
export { flipnovelPaymentConfig } from './flipnovel'
export { moonpagePaymentConfig } from './moonpage'
export { storlynPaymentConfig } from './storlyn'
export { novarisPaymentConfig } from './novaris'

/**
 * 获取当前品牌的完整支付配置
 */
export function getPaymentConfig(): BrandPaymentConfig {
  return loadBrandConfig({
    rocnovel: rocnovelPaymentConfig,
    oceread: ocereadPaymentConfig,
    talewave: talewavePaymentConfig,
    ficmoon: ficmoonPaymentConfig,
    novelarc: novelarcPaymentConfig,
    storyella: storyellaPaymentConfig,
    florastory: florastoryPaymentConfig,
    silktale: silktalePaymentConfig,
    pearla: pearlaPaymentConfig,
    fictora: fictoraPaymentConfig,
    marinovel: marinovelPaymentConfig,
    flipnovel: flipnovelPaymentConfig,
    moonpage: moonpagePaymentConfig,
    storlyn: storlynPaymentConfig,
    novaris: novarisPaymentConfig,
  })
}

/**
 * 获取当前品牌的充值页面配置
 */
export function getPayPageConfig(): PayPageConfig {
  return getPaymentConfig().pay
}

/**
 * 获取当前品牌的订阅页面配置
 */
export function getSubscribePageConfig(): SubscribePageConfig {
  return getPaymentConfig().subscribe
}

/**
 * 获取当前品牌的阅读器弹窗配置
 */
export function getChapterConfig(): ChapterConfig {
  return getPaymentConfig().chapter
}

/**
 * 按场景加载配置的辅助函数
 * 用于组件内加载特定场景的品牌配置
 */
export function loadPaymentConfigByScene<T extends 'pay' | 'subscribe' | 'chapter'>(
  scene: T,
): T extends 'pay' ? PayPageConfig : T extends 'subscribe' ? SubscribePageConfig : ChapterConfig {
  const config = getPaymentConfig()
  return config[scene] as any
}
